import Api from "../../tools/service";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../modals/ErrorModal";
import * as Yup from "yup";
import {persianToEnglish} from "../../tools/helpers";
import {useFormik} from "formik";
import React, {useContext, useState} from "react";
import TransactionalCreditContext from "../../tools/contexts/transationcalCredit/TransactionalCreditContext";
import Button from "../Button";
import {PiIdentificationCardThin} from "react-icons/pi";
import ConfirmModal from "../modals/ConfirmModal";
import Switch from "react-switch";
import REQUEST_URLS from "../../tools/defaults/requestUrl";

const GetInitInfo=({hasReset,handleBack=()=>{},isAddon,isAddonActive})=>{
    const transactionalCreditContext=useContext(TransactionalCreditContext)
    const [loading,setLoading]=useState(false);

    const [registered,setRegistered]=useState(hasReset);

    const handleSubmit=(values)=>{
        setLoading(true);
        const data={
            NationalId:persianToEnglish(values.NationalId),
            pid:transactionalCreditContext.pid,
            is_user_add_on:isAddon,
        };

        Api.put(REQUEST_URLS.TRANSACTIONAL_CREDIT.INIT_CONFIRM,data,{
            headers:{
                "Authorization": `Bearer ${transactionalCreditContext.token}`
            }
        }).then((response=>{
            const {data,status,message,hasError}=response;
            if(hasError){
                setLoading(false)
                transactionalCreditContext.handleError({
                    status,
                    message,
                    data,
                    pid:transactionalCreditContext.pid,
                    callback:()=>{
                        Reoverlay.showModal(ErrorModal,{
                            title:'خطا',
                            message:message||'خطای سرویس' ,
                            onConfirm:()=>{

                            },
                            confirmButtonText: '',
                            showConfirmButton:false,
                            showCancelButton:true,
                            cancelButtonText:'بستن',
                            cancelButtonTheme:'red',
                            onCancel:()=>{
                                Reoverlay.hideModal();

                            }
                        })
                    }
                })
            }else {
                transactionalCreditContext.handleGetProcess(transactionalCreditContext.pid);
            }
        })).catch(e=>{

        })
    }
    const ValidationSchema = Yup.object().shape({
        NationalId: Yup.string()
            .min(10, 'کد ملی عددی ۱۰ رقمی می باشد.')
            .max(10, 'کد ملی عددی ۱۰ رقمی می باشد.')
            .required('  کد ملی را وارد کنید.').test("isNumber", " کد ملی عددی می باشد", (value) => {
                if (!value) {
                    return false
                }
                return !isNaN(persianToEnglish(value))
            }),

    });
    const formik = useFormik({
        initialValues: {
            NationalId:'',

        },
        validationSchema:ValidationSchema,
        onSubmit: handleSubmit,
    });
    const handleSwitch=(checked)=>{
        setRegistered(checked)
    }
    return <div className="w-11/12 md:w-6/12 mx-auto">

        <div className="border-b flex  items-center flex justify-start   my-5 pb-5  ">
            <div className="p-3 flex justify-center items-center bg-green-200 rounded-full   ">
                <PiIdentificationCardThin className="text-4xl text-green-700 "/>
            </div>
            <div className="p-3 mt-5 ">
                <h1 className="    text-xl ">تکمیل اطلاعات </h1>
                <p className="text-sm ">برای ادامه مراحل کد ملی خود را وارد کنید</p>
            </div>
        </div>
        {!hasReset &&<div className="p-5 rounded-lg mb-3       bg-white ">
            <h2 className="text-lg mb-3 pb-3 border-b  font-bold">الزامات</h2>
            <p className="text-sm ">برای استعلام وضعیت معاملاتی باید در سامانه ثنا ثبت نام کرده باشید.</p>
        </div>}

        <form className="bg-white p-5 rounded-xl " onSubmit={formik.handleSubmit} >
            <label className="text-sm mb-1 " htmlFor="NationalId">کد ملی </label>
            <input  dir="ltr"   onChange={formik.handleChange} value={formik.values.NationalId}  type="tel" className="w-full mt-1  bg-gray-100  text-right rounded-xl p-3" placeholder="کد ملی را وارد کنید"
                    name="NationalId"/>
            {formik.errors.NationalId && formik.touched.NationalId ? (
                <p className="text-red-400 text-sm font-light mt-1 ">{formik.errors.NationalId}</p>
            ) : null}
            {
                !hasReset &&  <div className="flex  py-3  justify-between items-center">

                    <Switch  onColor="#36b570" onChange={handleSwitch} dir="rtl" size={50} checkedIcon={false} uncheckedIcon={false} height={20} width={40}
                            checked={registered}/>
                    <span className="text-sm">در سامانه ثنا ثبت نام کرده‌ام</span>
                </div>
            }

            <div className={`${isAddonActive ? 'grid grid-cols-2 gap-2' :'grid grid-cols-1'}`}>
                {isAddonActive && <Button onClick={handleBack}  className="text-sm mt-5 border-t border-gray-200 w-full rounded-lg " theme="light" type={"button"}>بازگشت</Button>}
                <Button disabled={!registered} loading={loading} className="text-sm mt-5 border-t border-gray-200 w-full rounded-lg " theme="green" type={"submit"}>ادامه</Button>

            </div>
        </form>
    </div>
}
export default GetInitInfo;